import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
  jobId:any
  jobData:any
  hunting_data=[]
  payment_data=[]
  user_role:any
  payment_model={
    mode: '',
    job_id: '',
    paid_amount: '',
    payment_notes: '',
    payment_status: '',
    next_paymentdate:''
  }
  paymentMode=[]
  pamentStatusList = [
    { name: 'received',label:'Payment Received' },
    { name: 'due',label:'Payement Due' },
  ]
  selectedPaymentStatus='due'
  selectedPaymentMode='643680c792675911b577d7cc'
  paymentModeId='6436808f92675911b577d7c3'
  payment_id: any
  reports_modal = {
    job_id: '',
    hours: 0,
    rate: 0,
    limit: 0,
    completed: 0,
    type: '',
    payment_status: '',
    on_alert: '',
    mode: '',
    next_paymentdate: '',
    notes: '',
    admin_notes: '',
    fixed_amount: 0,
    payment_date: new Date(),
    farming_by: [],
  }
 onAlert_List = [
    { name: 'Yes'},
    { name: 'No'},
  ]
  selectedOnAlert = 'No'
  type_List = [
      { name: 'Hourly',id:'hourly'},  
      { name: 'Fixed',id:'fixed'},
  ]
  selected_type = 'hourly'
  isHourly: boolean = false
  isFixed: boolean = false
  selectedFarmingBy = null;
  selectedChannel = null;
  row_id: any
  usersList=[]
  constructor(private apiService:ApiService,
    private activatedroute:ActivatedRoute,
    private route: Router, private modalService: NgbModal,
    public toastr: ToastrService, ) { 
    this.activatedroute.paramMap.subscribe(params => { 
    this.user_role=JSON.parse(localStorage.getItem('user'))
    this.jobId = params.get('id');      
    });
  }

  ngOnInit(): void {
    this.getJobById()
    this.getPaymentByJobId(this.jobId)
    this.paymentModeList()
    this.getUsers()
  }
  getJobById(){
    this.apiService.getJobsById(this.jobId).subscribe((res:any)=>{
      if(res.statusCode == 200){
        for(let item of res?.data){
          this.jobData=item
        }
      }
    })
  }
  getPaymentByJobId(id){
    this.apiService.getPaymentReportsById(id).subscribe((res:any)=>{
      if(res.statusCode == 200){
        this.payment_data = res.data
        // getPaymentReportsById  getTransactionByJobId
      }
    })
  }
  back(){
    this.route.navigate(['/jobs/list']) 
  }
  paymentModeList(){
    this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
      this.paymentMode = res.data
    })
  }
  getPaymentModeId(event:any){
    this.selectedPaymentMode
  }
  openModal(content,data){
    const modalOptions: NgbModalOptions = {
      // size: 'lg' // Set custom width here
    };
    this.payment_id=data._id
    this.selectedPaymentMode=data.mode._id
    this.selectedPaymentStatus=data.payment_status

    this.payment_model.mode = this.selectedPaymentMode
    this.payment_model.job_id = this.payment_model.job_id
    this.payment_model.paid_amount = data.paid_amount
    this.payment_model.payment_notes = data.payment_notes
    this.payment_model.payment_status = this.selectedPaymentStatus
    this.payment_model.next_paymentdate = data.next_paymentdate
    
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updatePayment(){
    if(this.payment_id){
      this.payment_model.payment_status =this.selectedPaymentStatus
      this.apiService.updateJobTransaction(this.payment_id,this.payment_model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.modalService.dismissAll()
          this.toastr.success('payment updated successfully!')
          this.getPaymentByJobId(this.jobId)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  }
  deletePayment(id,password){
    this.apiService.deleteJobTransaction(id,password).subscribe((res:any)=>{
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getPaymentByJobId(this.jobId)
      }
      else{
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }
    // ================== Delete Alert ========================
    confirmDelete(id:any) {
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then( (result)=> {
        if (result.value) {  
          this.deletePayment(id,result.value)      
          
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
  CompareDate(date) {
    var currentDate = new Date()
    if (currentDate >= new Date(date)) {
      return true;
    } else {
      return false;
    }
  }
  openModalAddPayment(content,id) {
    this.payment_model.job_id=id
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
    this.getPaymentByJobId(this.payment_model.job_id)
  }
  payment(){
    let body={
        mode: this.selectedPaymentMode,
        job_id: this.payment_model.job_id,
        paid_amount: this.payment_model.paid_amount,
        payment_notes: this.payment_model.payment_notes,
        payment_status: this.selectedPaymentStatus,
        next_paymentdate: this.payment_model.next_paymentdate,
     }
   if(this.payment_model.job_id){
    this.apiService.createJobTransaction(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('Payment Successfull')
        this.modalService.dismissAll()
        this.getPaymentByJobId(this.jobId)
      }
      else{
        this.toastr.error(res.error)
      }
     })
   }
  }
  openAddModal(content, prop, data) {
    
    if (prop === 'add new' && data) {
      console.log('==', data)
      this.selected_type = data.type
      if (this.selected_type === 'hourly') this.isHourly = true
      if(this.selected_type ==='fixed') this.isFixed = true
      this.reports_modal.hours = data.hours
      this.reports_modal.limit = data.limit
      this.reports_modal.rate = data.rate
      if (data.farming_by) {
        this.selectedFarmingBy = data?.farming_by[0]?._id
      }
      else this.selectedFarmingBy = null
    }
    if (prop === 'update' && data) {
      this.row_id = data._id
      this.reports_modal = data
      this.selected_type = data.type
      if (this.selected_type === 'hourly') this.isHourly = true
      if(this.selected_type ==='fixed') this.isFixed = true
      
      this.selectedPaymentStatus = data.payment_status
      this.selectedOnAlert = data.on_alert
      this.selectedPaymentMode = data.mode[0]._id
      this.reports_modal.hours = data.hours
      this.reports_modal.completed = data.completed
      this.reports_modal.limit = data.limit
      this.reports_modal.rate = data.rate
      this.reports_modal.payment_date = data.payment_date
      this.reports_modal.notes = data.notes
      this.reports_modal.admin_notes = data.admin_notes
      this.selectedFarmingBy = data.farming_by[0]._id
    }
   
      const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content,options);
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
        this.isHourly = false
        this.isFixed = false
        this.row_id = null
        this.selectedPaymentStatus = 'due'
        this.selectedOnAlert = 'No'
        this.selectedPaymentMode = '6436812a92675911b577d800'
        this.selected_type = null
        this.reports_modal.hours = 0
        this.reports_modal.rate = 0
        this.reports_modal.limit = 0
        this.reports_modal.completed = 0
        this.reports_modal.payment_date = null
        this.selectedFarmingBy = null
      }, (reason) => {
        this.isHourly = false
        this.isFixed = false
        this.row_id = null
        this.selectedPaymentStatus = 'due'
        this.selectedOnAlert = 'No'
        this.selectedPaymentMode = '6436812a92675911b577d800'
        this.selected_type = null
        this.reports_modal.hours = 0
        this.reports_modal.rate = 0
        this.reports_modal.limit = 0
        this.reports_modal.completed = 0
        this.reports_modal.payment_date = null
        this.selectedFarmingBy = null
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  addPayment() {
    if (!this.row_id) {
      this.reports_modal.job_id = this.jobId
      this.reports_modal.mode = this.selectedPaymentMode
      this.reports_modal.on_alert = this.selectedOnAlert
      this.reports_modal.payment_status = this.selectedPaymentStatus
      this.reports_modal.type = this.selected_type
      this.reports_modal.farming_by = this.selectedFarmingBy
      this.apiService.addPaymentReports(this.reports_modal).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.toastr.success('Added successfully')
          this.modalService.dismissAll()
          this.getPaymentByJobId(this.jobId)
        }
        else this.toastr.error(res?.message)
      })
    }
    if (this.row_id) {
       this.reports_modal.job_id = this.jobId
      this.reports_modal.mode = this.selectedPaymentMode
      this.reports_modal.on_alert = this.selectedOnAlert
      this.reports_modal.payment_status = this.selectedPaymentStatus
      this.reports_modal.type = this.selected_type
      this.reports_modal.farming_by = this.selectedFarmingBy
      this.apiService.updateJobTransaction(this.row_id,this.reports_modal).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Updated successfully')
        this.modalService.dismissAll()
        this.getPaymentByJobId(this.jobId)
      }
      else this.toastr.error(res?.message)
    })
    }
  }
    getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
    })
  }
   getFarmId(event: any) {
     this.selectedFarmingBy
   
    }
    
}
